<template>
  <div class="order-detail-contain">
    <el-tabs v-model="activeName" @tab-change="handleClick">
      <el-tab-pane label="采购单入库基本信息" name="first">
        <createList @getPurchaseInfo="getPurchaseInfo"></createList>
      </el-tab-pane>
      <el-tab-pane
        label="采购单入库详情信息"
        name="second"
        :disabled="secondAble"
      >
        <createDetails
          ref="detailInfo"
          :createListInfo="createListInfo"
        ></createDetails>
      </el-tab-pane>
    </el-tabs>
  </div>
</template>
<script>
import { computed, ref } from "vue";
import createList from "./createList.vue";
import createDetails from "./createDetails.vue";
import { useRoute } from "vue-router";
export default {
  name: "inspectPurchaseOrder",
  components: {
    createDetails,
    createList,
  },
  setup() {
    const pur_id = ref("");
    const pur_no = ref("");
    const detailInfo = ref(null);
    const route = ref(useRoute());
    const secondAble = computed(() => {
      let flag = route.value.query.arrData[0] == "udt" || pur_id.value;
      return !flag;
    });
    const createListInfo = ref(null);
    const activeName = ref("first");
    const handleClick = (TabPanelName) => {
      if (TabPanelName == "second") {
        detailInfo.value.getPurchaseDetails();
      }
    };
    const getPurchaseInfo = (val) => {
      const obj = detailInfo.value;
      obj.pur_id = val.pur_id;
      obj.pur_no = val.pur_no;
      activeName.value = "second";
      obj.getPurchaseDetails();
    };
    return {
      activeName,
      handleClick,
      getPurchaseInfo,
      createListInfo,
      secondAble,
      detailInfo,
      pur_no,
    };
  },
};
</script>
<style scoped>
.order-detail-contain {
  padding: 20px 0;
}
</style>
